import script from "./form3View.vue?vue&type=script&setup=true&lang=js"
export * from "./form3View.vue?vue&type=script&setup=true&lang=js"

import "./form3View.vue?vue&type=style&index=0&id=665cf495&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-665cf495"]])

export default __exports__